var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2198_24594)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 3.16797H20V21.5013H0V3.16797Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.00292964 3.16927L10.002 -2.16406L20.001 3.16927V9.16927H0L0.00292964 3.16927Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.95898 9.12109H17.0215V12.4023H2.95898V9.12109Z",
    fill: "#0072C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.001 20.8346V3.1709V3.16797L9.99903 18.168L0 3.16797V3.1709V20.8346L8.83431 21.3346L20.001 20.8346Z",
    fill: "#CE1126"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2383 9.12402L13 8.5586L14.9014 7.12304L12.5664 7.45702L13.7676 5.4209L11.6963 6.62207L12.0713 4.25195L10.668 6.12109L10.1025 3.95312L9.46679 6.18847L8.06639 4.28418L8.46777 6.72167L6.39354 5.45313L7.59472 7.48927L5.32714 7.12304L7.19627 8.52345L4.85547 9.12402H15.2353H15.2383Z",
    fill: "#FCD116"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2198_24594"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 20,
    height: 20,
    rx: 10,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAg);
export default __webpack_public_path__ + "static/media/AG.aa91831e558bb13f57d50951380173c6.svg";
export { ForwardRef as ReactComponent };